module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '90%' : '40%',
      "persistent": ""
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', {
    staticClass: "popup-modal"
  }, [_c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-0': _vm.isMobileSize, 'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("\n          Dados Censo da Educação Superior\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n            Olá "), _c('strong', [_vm._v(_vm._s(_vm.primeiroNome))]), _vm._v(", precisamos que você informe alguns dados para o Censo da Educação Superior 2024. É rápido e leva menos de um minuto. \n            "), _c('br'), _c('a', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "href": 'https://docs.google.com/forms/d/e/1FAIpQLSedO4Oq1WxmgpRBL0DKPwTca0gX30IzorBAl7Ak15TkqG8IXQ/viewform?entry.521200124=' + _vm.currentUser.ref_pessoa,
      "target": "_blank"
    }
  }, [_vm._v("\n              Clique aqui para responder\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Se você já respondeu, por favor, desconsidere esta mensagem e clique em \""), _c('span', {
    on: {
      "click": function($event) {
        _vm.mostrarModal = false
      }
    }
  }, [_vm._v("Fechar")]), _vm._v("\".")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModal = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29aadfb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/popup/LinkFormPopup.vue
// module id = 532
// module chunks = 2